<template>
  <footer
      class="footer small-12"
      :style="customStyle"
  >
    <div class="row">
      <div class='footer-wrapper'>
        <ul class='content-footer-wrapper'>
          <li v-for="(section, index) in footerInfo.sections"
              :key="index"
              class='small-11 medium-2 large-2'>
            <h3 :style="customTextStyle">{{ section.label }}</h3>
            <template v-for="(link, index) in section.links" :key="index">
              <a v-if="link.link"
                  :href="link.link"
                  :style="customTextStyle"
                  :target="link.newWindow ? '_blank': ''">
                <img
                    class="footer-icon"
                    role="presentation"
                    alt=""
                    v-if="link.icon"
                    :src="link.icon">
                <i class="fa fa-fw"
                   :class="link.faIcon"
                   v-if="link.faIcon"
                   aria-hidden="true"></i>
                {{ link.label }}
              </a>
              <template v-else>
                <img
                    class="footer-icon"
                    role="presentation"
                    alt=""
                    v-if="link.icon"
                    :src="link.icon">
                <i class="fa fa-fw"
                   :class="link.faIcon"
                   v-if="link.faIcon"
                   aria-hidden="true"></i>
                {{ link.label }}
              </template>
              <br>
            </template>
            <span v-html="section.html"></span>
          </li>

          <li class='small-11 medium-2 large-2'>
            <div
                class="register-email"
                v-if="footerInfo.emailRegistration"
            >
              <h5>{{ footerInfo.emailRegistration.label }}</h5>
              <p>{{ footerInfo.emailRegistration.text }}</p>
              <div
                  class="recaptcha"
                  v-if="footerInfo.emailRegistration.useRecaptchaV2Checkbox"
              >
                <div class="g-recaptcha-js"></div>
              </div>
              <div class="register-email_input-btn_wrapper">
                <form aria-labelledby="register-email">
                  <fieldset>
                    <legend id="register-email" class="sr-only">{{ footerInfo.emailRegistration.label }}</legend>
                      <base-input
                          :placeholder="footerInfo.translations['email']"
                          aria-labelledby="register-email"
                          :showLabel="false"
                          v-model="inputEmail"
                          type="text"
                          class="register-email-input"
                      />
                      <base-button
                          class="button register-email-button"
                          button-type="submit"
                          @click="registerEmail"
                          :disableBtn="disableEmailBtn">
                        {{ footerInfo.translations['se.netset.etailer.node~OK']}}
                      </base-button>
                  </fieldset>
                </form>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="small-12 columns">
        <p class="footer-text">
          <span v-html="footerInfo.text"></span>
        </p>
      </div>
    </div>
    <div class="footer-switches">
      <language-selector/>
      <currency-selector/>
    </div>
  </footer>
</template>

<script>
import BaseButton from "components/UI/button/BaseButton";
import CurrencySelector from "components/currency/CurrencySelector";
import LanguageSelector from "components/language/LanguageSelector";
import BaseInput from "components/UI/input/BaseInput";
import netsetNode from 'netsetNode';
import recaptcha from 'recaptcha';
import messages from 'messages';


export default {
  components: {
    BaseInput,
    BaseButton,
    CurrencySelector,
    LanguageSelector
  },
  props: {
    footerInfo: {
      type: Object,
      required: true
    }
  },
  mounted() {
    recaptcha.renderWidgets('.recaptcha');
  },
  data() {
    return {
      inputEmail: '',
      inputEmailValid: 'unset',
      disableEmailBtn: true,
      //This is a general regex (matches the one in backend)
      emailRegex: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
    }
  },
  watch: {
    inputEmail(value) {
      this.inputEmailValid = (value === "") ? 'unset' : (this.emailRegex.test(value)) ? 'valid' : 'invalid';
      this.disableEmailBtn = this.inputEmailValid !== 'valid';
    }
  },
  computed: {
    customStyle() {
      return {}
    },
    customTextStyle() {
      return {}
    },
  },
  methods: {
    registerEmail() {
      const vm = this;
      this.disableEmailBtn = true;
      let data = this.recaptchaData({email: this.inputEmail});
      netsetNode.call('/nodeapi/register_email', data)
          .then(function (response) {
            if (response.link) {
              location.href = response.link;
            } else {
              messages.showSuccessMsg(
                  this.footerInfo.translations['email.successfully.submitted']
              );
            }
            vm.inputEmail = '';
            vm.inputEmailValid = 'unset';
            vm.disableEmailBtn = false;
          })
          .catch(function (status) {
            messages.showErrorMsg(status.message);
            vm.inputEmail = '';
            vm.inputEmailValid = 'unset';
            vm.disableEmailBtn = false;
          })
    },
    recaptchaData(data) {
      recaptcha.addUserResponseToken({
        targetData: data,
        widgetContainerSelector: '.register-email',
      });
      return data;
    }
  }
}
</script>

<style scoped lang="scss">
.register-email-input {
  &.invalid {
    outline: none;
    border: 1px solid red;
    box-shadow: 0 0 10px red;
  }

  &.valid {
    outline: none;
    border: 1px solid green;
    box-shadow: 0 0 10px green;
  }
}
</style>